import { addDays, format, parseISO } from "date-fns";
import { toZonedTime } from "date-fns-tz";

export const convertUTCStringToZonedString = (
  utcString: string,
  timezone: string,
  { daysToAdd = 0 }: { daysToAdd?: number } = {},
) => {
  const utcDate = parseISO(utcString);
  const targetDate = addDays(utcDate, daysToAdd);
  const zonedDate = toZonedTime(targetDate, timezone);

  return format(zonedDate, "yyyy-MM-dd'T'HH:mm:ss");
};

export const isValidTimeZone = (timezone: string) =>
  !Number.isNaN(toZonedTime(new Date(), timezone).getTime());
